export const payload = {
  receiveMutation: 'RECEIVE_VENDORS',
  receivingMutation: 'RECEIVING_VENDORS',
  receiveMetadataMutation: 'RECEIVE_VENDOR_METADATA',
  savingMutation: 'SAVING_VENDOR',
  incrementMutation: 'INCREMENT_VENDOR_COUNT',
  updatingMutation: 'UPDATING_VENDOR',
  resetMetaMutation: 'RESET_VENDOR_META',
  clearMutation: 'CLEAR_VENDOR_STATE',
  moduleName: 'vendor',
  endpoint: 'vendors',
  otherNames: ['parent', 'third_party_vendor'],
  nested: {
    address_contact: {
      receiveMutation: 'RECEIVE_ADDRESSES',
      listSchemaRequired: false,
      endpoint: 'addresses'
    },
    address_billing: {
      receiveMutation: 'RECEIVE_ADDRESSES',
      listSchemaRequired: false,
      endpoint: 'addresses'
    },
    address_mailing: {
      receiveMutation: 'RECEIVE_ADDRESSES',
      listSchemaRequired: false,
      endpoint: 'addresses'
    }
  }
}
